import axios, { AxiosRequestConfig } from "axios";
import { getAxiosConfig } from "./roundsService";

interface RoundData {
    rounds: string[];
}

export interface DeviceInfo {
    deviceId: string,
    deviceInfo: object
}

export interface ClockDriftData {
    minutes: number[],
    expectedTuts: number[],
    actualTuts: number[],
    diffInTuts: number[],
    accumulatedDiffs: number[]
}


export const getAvailableRounds = (jwtToken: string): Promise<RoundData> => {
    return axios
    .get(
        `https://api.triangula.com//round/raw/analysis/supportedRoundNames`,
        getAxiosConfig(jwtToken)
    )
    .then((response) => {
        return response.data as RoundData;
    })
    .catch((error) => {
        console.error("Error fetching available rounds:", error);
        throw new Error("Failed to fetch available rounds");
    });
}

export const getDevicesInRound = (jwtToken: string, roundName: string): Promise<{devices: DeviceInfo[]}> => {
    return axios
        .get(
            `https://api.triangula.com/round/raw/analysis/${roundName}/devices`,
            getAxiosConfig(jwtToken)
        )
        .then((response) => {
            return response.data as {devices: DeviceInfo[]};
        })
        .catch((error) => {
            console.error("Error fetching devices in round:", error);
            throw new Error("Failed to fetch devices in round");
        });
}

export const getApproximatedClockDrift = ( jwtToken: string, deviceId: string, roundName: string): Promise<{ [key: string]: ClockDriftData }> => {
    return axios
        .get(
            `https://api.triangula.com/round/raw/analysis/${roundName}/${deviceId}/clockDrift`,
            getAxiosConfig(jwtToken)
        )
        .then((response) => {
            return response.data as { [key: string]: ClockDriftData };
        })
        .catch((error) => {
            console.error("Error fetching clock drift data:", error);
            throw new Error("Failed to fetch clock drift data");
        });
}
